module.exports = __webpack_public_path__ + "00_hair.0f5669fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/00_hair.png
// module id = B4Xs
// module chunks = 0